// extracted by mini-css-extract-plugin
export default {"spinner":"components-spinner_spinner","sk-bouncedelay":"components-spinner_sk-bouncedelay","bounce1":"components-spinner_bounce1","bounce2":"components-spinner_bounce2"};